<script lang="ts" setup>
import SpecialistSpecialities from '~/components/specialist/SpecialistSpecialities.vue'
import ImageSize from '~/enums/image-size'
import helpers from '~/helpers'
import { useImageStore } from '~/store/image'
import type { SpecialistData } from '~/types/specialists'

const props = defineProps<{
  specialistData: SpecialistData
}>()

const imageStore = useImageStore()
const { getImages, isWebp } = storeToRefs(imageStore)

const getAvatar = computed(() => getImages.value(ImageSize.X600, images.value)?.find(i => !isWebp.value(i.meta.url)))
const images = computed(() => props.specialistData.relationships.images?.data)
const specialities = computed(() => props.specialistData?.relationships.specialities?.data)
</script>

<template>
  <article
    class="relative flex flex-col justify-end overflow-hidden rounded-3xl bg-main-blue p-5"
  >
    <div
      v-if="getAvatar && getImages.length"
      class="absolute inset-0 z-10 size-full bg-cover bg-center bg-no-repeat"
      :style="`background-image: url(${getAvatar.meta.url})`"
    />

    <div class="absolute inset-0 z-20 size-full bg-[rgba(0,0,0,.2)]"/>

    <div class="relative z-30 h-[104px] max-w-full">
      <strong class="text-[26px] font-medium leading-[1.08] !text-white">
        {{ helpers.getFullName(specialistData) }}
      </strong>

      <SpecialistSpecialities class="mt-1 !text-white [&_*]:!text-white" :specialities="specialities" />
    </div>
  </article>
</template>
